// src/utils/pointsConfig.js
//
// Fórmula base:
//   points = round( (durMin*wDur + distKm*wDist + cal*wCal + (steps/1000)*wSteps) * mult * volumeBonus )
//
// Critérios do multiplicador (mult):
//   - Base: MET médio da atividade (Compendium of Physical Activities, Ainsworth et al.)
//   - Ajuste +: alta complexidade técnica, engajamento corporal total, subnotificação calórica típica
//   - Ajuste -: muita pausa dentro da sessão (baseball, boliche), intensidade intermitente baixa
//   - Cap máximo: 1.40 (evita inflação)

export const POINTS_CONFIG = {

  // ── MUSCULAÇÃO ──────────────────────────────────────────────────────────────
  // MET musculação ~5-6 | MET calistenia ~5-8 | MET levantamento olímpico ~6
  // Levantamento de peso leva +0.05 por técnica e pico de potência
  musculacao:          { category: "Musculação",            wDur: 4.0, wDist:  0,  wCal: 0.060, wSteps: 0,   mult: 1.20, met: 5.5 },
  calistenia:          { category: "Musculação",            wDur: 3.8, wDist:  0,  wCal: 0.060, wSteps: 0,   mult: 1.20, met: 6.5 },
  levantamento_peso:   { category: "Musculação",            wDur: 4.2, wDist:  0,  wCal: 0.065, wSteps: 0,   mult: 1.25, met: 6 },

  // ── CORRIDA ─────────────────────────────────────────────────────────────────
  // MET corrida ~10-12 dependendo do ritmo
  corrida:             { category: "Corrida",               wDur: 3.0, wDist: 35,  wCal: 0.050, wSteps: 3.0, mult: 1.35, met: 11 },

  // ── CICLISMO ────────────────────────────────────────────────────────────────
  // MET ciclismo estrada ~8-10 | MTB ~10-14 (terreno irregular eleva MET)
  // Spinning sem distância real, mas MET alto (~9-10)
  ciclismo:            { category: "Ciclismo",              wDur: 2.5, wDist: 18,  wCal: 0.050, wSteps: 0,   mult: 1.25, met: 9 },
  mountain_bike:       { category: "Ciclismo",              wDur: 2.8, wDist: 20,  wCal: 0.060, wSteps: 0,   mult: 1.32, met: 12 },
  spinning:            { category: "Ciclismo",              wDur: 2.8, wDist:  0,  wCal: 0.065, wSteps: 0,   mult: 1.28, met: 9.5 },

  // ── MÁQUINA DE CARDIO ───────────────────────────────────────────────────────
  // MET esteira ~7-9 | elíptica ~6 | remo ergômetro ~7-8
  esteira:             { category: "Máquina de cardio",     wDur: 2.5, wDist: 18,  wCal: 0.050, wSteps: 1.5, mult: 1.15, met: 8 },
  eliptica:            { category: "Máquina de cardio",     wDur: 2.4, wDist:  0,  wCal: 0.055, wSteps: 0,   mult: 1.18, met: 6 },
  remo:                { category: "Máquina de cardio",     wDur: 2.8, wDist:  0,  wCal: 0.060, wSteps: 0,   mult: 1.25, met: 7.5 },

  // ── MENTE E CORPO ───────────────────────────────────────────────────────────
  // MET yoga ~3 | pilates ~3-4 | barre ~3.5 | meditação ~1.5 | respiração ~1.5
  // Sem mult alto: pontos dependem de duração (incentiva sessões longas de recovery)
  yoga:                { category: "Mente e corpo",         wDur: 2.0, wDist:  0,  wCal: 0.035, wSteps: 0,   mult: 1.03, met: 3 },
  pilates:             { category: "Mente e corpo",         wDur: 2.5, wDist:  0,  wCal: 0.040, wSteps: 0,   mult: 1.08, met: 3.5 },
  barre:               { category: "Mente e corpo",         wDur: 2.5, wDist:  0,  wCal: 0.040, wSteps: 0,   mult: 1.08, met: 3.5 },
  meditacao:           { category: "Mente e corpo",         wDur: 1.5, wDist:  0,  wCal: 0.015, wSteps: 0,   mult: 1.00, met: 1.5 },
  respiracao:          { category: "Mente e corpo",         wDur: 1.5, wDist:  0,  wCal: 0.020, wSteps: 0,   mult: 1.00, met: 1.5 },
  mente_e_corpo:       { category: "Mente e corpo",         wDur: 2.0, wDist:  0,  wCal: 0.030, wSteps: 0,   mult: 1.02, met: 3 },

  // ── TREINAMENTO FUNCIONAL ───────────────────────────────────────────────────
  // HIIT/CrossFit: MET ~12-15 (mais alto do compêndio em sessões reais)
  // Bootcamp/circuito: MET ~10-12
  // Funcional/cross_training: MET ~8-10
  // Ginástica artística: MET ~5-7 (muito técnico mas intermitente)
  hiit:                { category: "Treinamento funcional", wDur: 3.8, wDist:  0,  wCal: 0.075, wSteps: 0,   mult: 1.38, met: 13.5 },
  crossfit:            { category: "Treinamento funcional", wDur: 3.8, wDist:  0,  wCal: 0.075, wSteps: 0.5, mult: 1.40, met: 13.5 },
  bootcamp:            { category: "Treinamento funcional", wDur: 3.5, wDist:  0,  wCal: 0.070, wSteps: 1.0, mult: 1.35, met: 11 },
  circuito:            { category: "Treinamento funcional", wDur: 3.2, wDist:  0,  wCal: 0.065, wSteps: 0,   mult: 1.28, met: 11 },
  cross_training:      { category: "Treinamento funcional", wDur: 3.2, wDist:  0,  wCal: 0.065, wSteps: 0.5, mult: 1.28, met: 9 },
  funcional:           { category: "Treinamento funcional", wDur: 3.2, wDist:  0,  wCal: 0.065, wSteps: 0,   mult: 1.25, met: 9 },
  ginastica:           { category: "Treinamento funcional", wDur: 3.0, wDist:  0,  wCal: 0.055, wSteps: 0,   mult: 1.20, met: 6 },

  // ── TREINO CORE ─────────────────────────────────────────────────────────────
  // MET ~3.5-4 (exercícios isolados, menos demanda sistêmica)
  abdominais:          { category: "Treino core",           wDur: 3.2, wDist:  0,  wCal: 0.050, wSteps: 0,   mult: 1.10, met: 3.8 },
  treino_core:         { category: "Treino core",           wDur: 3.0, wDist:  0,  wCal: 0.050, wSteps: 0,   mult: 1.10, met: 3.8 },

  // ── AERÓBICA ────────────────────────────────────────────────────────────────
  // Pular corda MET ~11-12 | Zumba/aeróbica ~6-8 | dança ~5-7
  // Pole dance: MET ~5-7 + complexidade técnica alta → +0.05 vs dança
  // Hidroginástica: MET ~5, resistência da água subnotifica esforço real
  corda:               { category: "Aeróbica",              wDur: 3.5, wDist:  0,  wCal: 0.070, wSteps: 0,   mult: 1.35, met: 11.5 },
  aerobica:            { category: "Aeróbica",              wDur: 2.8, wDist:  0,  wCal: 0.060, wSteps: 0,   mult: 1.20, met: 7 },
  zumba:               { category: "Aeróbica",              wDur: 2.8, wDist:  0,  wCal: 0.060, wSteps: 0,   mult: 1.20, met: 7 },
  cardio_misto:        { category: "Aeróbica",              wDur: 2.8, wDist:  0,  wCal: 0.060, wSteps: 0,   mult: 1.20, met: 7 },
  pole_dance:          { category: "Aeróbica",              wDur: 3.0, wDist:  0,  wCal: 0.060, wSteps: 0,   mult: 1.22, met: 6 },
  danca:               { category: "Aeróbica",              wDur: 2.6, wDist:  0,  wCal: 0.055, wSteps: 0,   mult: 1.15, met: 6 },
  hidroginastica:      { category: "Aeróbica",              wDur: 2.4, wDist:  0,  wCal: 0.055, wSteps: 0,   mult: 1.15, met: 5 },
  jogos_exercicio:     { category: "Aeróbica",              wDur: 2.4, wDist:  0,  wCal: 0.050, wSteps: 1.5, mult: 1.12, met: 5 },

  // ── ARTES MARCIAIS ──────────────────────────────────────────────────────────
  // Muay Thai: MET ~12 (mais cardio intenso do grupo) → 1.40
  // BJJ: MET ~10-11 + alta demanda técnica e anaeróbica → 1.38
  // Boxe/kickboxing: MET ~10-11 → 1.35/1.32
  // Luta genérica: MET ~10 → 1.30
  // Tai Chi: MET ~3 (meditativo) → 1.05
  muay_thai:           { category: "Artes marciais",        wDur: 3.8, wDist:  0,  wCal: 0.075, wSteps: 0,   mult: 1.40, met: 12 },
  bjj:                 { category: "Artes marciais",        wDur: 3.5, wDist:  0,  wCal: 0.070, wSteps: 0,   mult: 1.38, met: 10.5 },
  boxe:                { category: "Artes marciais",        wDur: 3.5, wDist:  0,  wCal: 0.070, wSteps: 0,   mult: 1.35, met: 10.5 },
  kickboxing:          { category: "Artes marciais",        wDur: 3.5, wDist:  0,  wCal: 0.070, wSteps: 0,   mult: 1.32, met: 10.5 },
  luta:                { category: "Artes marciais",        wDur: 3.5, wDist:  0,  wCal: 0.070, wSteps: 0,   mult: 1.30, met: 10 },
  artes_marciais:      { category: "Artes marciais",        wDur: 3.2, wDist:  0,  wCal: 0.065, wSteps: 0,   mult: 1.28, met: 10 },
  tai_chi:             { category: "Artes marciais",        wDur: 2.0, wDist:  0,  wCal: 0.030, wSteps: 0,   mult: 1.05, met: 3 },

  // ── ESPORTES EM EQUIPE ──────────────────────────────────────────────────────
  // Futebol/rugby/polo aquático: MET ~10-12 (muita corrida ou resistência aquática)
  // Basquete/hóquei: MET ~8-10
  // Vôlei/frisbee: MET ~6-8 (mais pausas)
  // Beisebol/cricket/softbol: MET ~4-5 (muita espera) → ajuste negativo
  polo_aquatico:       { category: "Esportes em equipe",    wDur: 3.5, wDist:  0,  wCal: 0.070, wSteps: 0,   mult: 1.38, met: 10 },
  futebol:             { category: "Esportes em equipe",    wDur: 3.2, wDist:  7,  wCal: 0.065, wSteps: 3.0, mult: 1.32, met: 11 },
  rugby:               { category: "Esportes em equipe",    wDur: 3.2, wDist:  5,  wCal: 0.070, wSteps: 2.5, mult: 1.32, met: 11 },
  hoquei_gelo:         { category: "Esportes em equipe",    wDur: 3.2, wDist:  0,  wCal: 0.070, wSteps: 0,   mult: 1.32, met: 9 },
  futebol_australiano: { category: "Esportes em equipe",    wDur: 3.2, wDist:  8,  wCal: 0.065, wSteps: 2.5, mult: 1.30, met: 11 },
  lacrosse:            { category: "Esportes em equipe",    wDur: 3.2, wDist:  6,  wCal: 0.065, wSteps: 2.5, mult: 1.30, met: 9 },
  hoquei_grama:        { category: "Esportes em equipe",    wDur: 3.0, wDist:  6,  wCal: 0.065, wSteps: 2.5, mult: 1.28, met: 9 },
  basquete:            { category: "Esportes em equipe",    wDur: 3.0, wDist:  5,  wCal: 0.065, wSteps: 3.0, mult: 1.28, met: 9 },
  futebol_americano:   { category: "Esportes em equipe",    wDur: 2.8, wDist:  0,  wCal: 0.065, wSteps: 2.0, mult: 1.25, met: 8 },
  futevolei:           { category: "Esportes em equipe",    wDur: 3.0, wDist:  0,  wCal: 0.065, wSteps: 2.0, mult: 1.28, met: 7 },
  handebol:            { category: "Esportes em equipe",    wDur: 3.0, wDist:  5,  wCal: 0.065, wSteps: 2.5, mult: 1.28, met: 9 },
  ultimate_frisbee:    { category: "Esportes em equipe",    wDur: 3.0, wDist:  5,  wCal: 0.065, wSteps: 3.0, mult: 1.28, met: 7 },
  volei_praia:         { category: "Esportes em equipe",    wDur: 2.8, wDist:  0,  wCal: 0.060, wSteps: 2.0, mult: 1.25, met: 8 },
  voleibol:            { category: "Esportes em equipe",    wDur: 2.6, wDist:  0,  wCal: 0.055, wSteps: 1.5, mult: 1.20, met: 6 },
  esporte_equipe:      { category: "Esportes em equipe",    wDur: 2.5, wDist:  0,  wCal: 0.050, wSteps: 1.5, mult: 1.20, met: 7 },
  cricket:             { category: "Esportes em equipe",    wDur: 2.0, wDist:  0,  wCal: 0.040, wSteps: 1.0, mult: 1.15, met: 4.5 },
  beisebol:            { category: "Esportes em equipe",    wDur: 2.0, wDist:  0,  wCal: 0.040, wSteps: 1.0, mult: 1.15, met: 4.5 },
  softbol:             { category: "Esportes em equipe",    wDur: 2.0, wDist:  0,  wCal: 0.040, wSteps: 1.0, mult: 1.15, met: 4.5 },

  // ── TRILHA ──────────────────────────────────────────────────────────────────
  // Mochilagem: MET ~7 (peso extra eleva demanda) → distância e passos pesados
  // Trilha: MET ~6 (terreno irregular vs caminhada plana)
  // Caminhada: MET ~3.5 → mult baixo, mas valoriza volume (distância + passos)
  mochilagem:          { category: "Trilha",                wDur: 2.5, wDist: 15,  wCal: 0.050, wSteps: 2.5, mult: 1.22, met: 7 },
  trilha:              { category: "Trilha",                wDur: 2.2, wDist: 12,  wCal: 0.045, wSteps: 2.5, mult: 1.18, met: 6 },
  caminhada:           { category: "Trilha",                wDur: 2.0, wDist: 12,  wCal: 0.040, wSteps: 2.5, mult: 1.05, met: 3.5 },

  // ── ESCALADA ────────────────────────────────────────────────────────────────
  // MET escalada ~8-11 + altíssima demanda técnica e força relativa
  // Boulder: MET ~10-11, esforços máximos explosivos, alta técnica → 1.38
  // Rocha: MET ~10 + fator outdoor/risco → 1.40 (cap)
  // Indoor: igual boulder mas ambiente controlado → 1.30
  escalada_rocha:      { category: "Escalada",              wDur: 3.5, wDist:  0,  wCal: 0.070, wSteps: 0,   mult: 1.40, met: 10 },
  boulder:             { category: "Escalada",              wDur: 3.5, wDist:  0,  wCal: 0.065, wSteps: 0,   mult: 1.38, met: 10.5 },
  escalada:            { category: "Escalada",              wDur: 3.2, wDist:  0,  wCal: 0.065, wSteps: 0,   mult: 1.32, met: 9 },
  escalada_indoor:     { category: "Escalada",              wDur: 3.2, wDist:  0,  wCal: 0.065, wSteps: 0,   mult: 1.30, met: 10 },

  // ── ESPORTE DE RAQUETE ──────────────────────────────────────────────────────
  // Squash: MET ~12 (esporte mais intenso do grupo) → 1.38
  // Tênis/beach tênis/padel: MET ~7-8 → 1.25-1.28
  // Badminton: MET ~7 → 1.22
  // Pickleball/paddle: MET ~5-6 (mais recreativo) → 1.18
  squash:              { category: "Esporte de raquete",    wDur: 3.5, wDist:  0,  wCal: 0.075, wSteps: 2.5, mult: 1.38, met: 12 },
  racquetball:         { category: "Esporte de raquete",    wDur: 3.2, wDist:  0,  wCal: 0.070, wSteps: 2.0, mult: 1.30, met: 10 },
  tenis:               { category: "Esporte de raquete",    wDur: 3.0, wDist:  0,  wCal: 0.065, wSteps: 2.0, mult: 1.28, met: 7.5 },
  beach_tenis:         { category: "Esporte de raquete",    wDur: 3.0, wDist:  0,  wCal: 0.065, wSteps: 2.0, mult: 1.28, met: 7.5 },
  padel:               { category: "Esporte de raquete",    wDur: 3.0, wDist:  0,  wCal: 0.065, wSteps: 2.0, mult: 1.25, met: 7.5 },
  badminton:           { category: "Esporte de raquete",    wDur: 2.8, wDist:  0,  wCal: 0.060, wSteps: 2.0, mult: 1.22, met: 7 },
  pickleball:          { category: "Esporte de raquete",    wDur: 2.6, wDist:  0,  wCal: 0.055, wSteps: 1.5, mult: 1.18, met: 5.5 },
  paddle:              { category: "Esporte de raquete",    wDur: 2.6, wDist:  0,  wCal: 0.055, wSteps: 1.5, mult: 1.18, met: 5.5 },

  // ── ESPORTES RECREATIVOS ────────────────────────────────────────────────────
  // Surfe: MET ~5-8 (paddling + técnica) → 1.25
  // Caiaque: MET ~5-7 → 1.20
  // Patinação: MET ~7 → 1.18
  // Skate: MET ~5-7 (muito variável, inclui pausa) → 1.15
  // Mergulho: MET ~5, trabalho muscular subaquático subnotificado → 1.12
  // Golfe: MET ~4.5 (caminhando) → 1.10
  // Hipismo/equitação: MET ~4-6 → 1.12
  // Tênis de mesa: MET ~4 → 1.10
  // Arco/disc golf/boliche: MET ~3-3.5 → 1.00-1.05
  surfe:               { category: "Esportes recreativos",  wDur: 2.8, wDist:  0,  wCal: 0.055, wSteps: 0,   mult: 1.25, met: 6.5 },
  caiaque:             { category: "Esportes recreativos",  wDur: 2.5, wDist:  8,  wCal: 0.055, wSteps: 0,   mult: 1.20, met: 6 },
  patinacao:           { category: "Esportes recreativos",  wDur: 2.5, wDist:  0,  wCal: 0.055, wSteps: 0,   mult: 1.18, met: 7 },
  skate:               { category: "Esportes recreativos",  wDur: 2.2, wDist:  5,  wCal: 0.045, wSteps: 0,   mult: 1.15, met: 6 },
  hipismo:             { category: "Esportes recreativos",  wDur: 2.2, wDist:  0,  wCal: 0.040, wSteps: 0,   mult: 1.12, met: 5 },
  equitacao:           { category: "Esportes recreativos",  wDur: 2.2, wDist:  0,  wCal: 0.040, wSteps: 0,   mult: 1.12, met: 5 },
  mergulho:            { category: "Esportes recreativos",  wDur: 2.2, wDist:  0,  wCal: 0.045, wSteps: 0,   mult: 1.12, met: 5 },
  golfe:               { category: "Esportes recreativos",  wDur: 2.0, wDist:  5,  wCal: 0.040, wSteps: 2.0, mult: 1.10, met: 4.5 },
  tenis_mesa:          { category: "Esportes recreativos",  wDur: 2.2, wDist:  0,  wCal: 0.040, wSteps: 0,   mult: 1.10, met: 4 },
  arco_flecha:         { category: "Esportes recreativos",  wDur: 2.0, wDist:  0,  wCal: 0.035, wSteps: 0,   mult: 1.05, met: 3.5 },
  disc_golf:           { category: "Esportes recreativos",  wDur: 2.0, wDist:  5,  wCal: 0.035, wSteps: 2.0, mult: 1.05, met: 3.5 },
  boliche:             { category: "Esportes recreativos",  wDur: 1.8, wDist:  0,  wCal: 0.030, wSteps: 0.5, mult: 1.00, met: 3 },
  esporte_recreativo:  { category: "Esportes recreativos",  wDur: 2.0, wDist:  0,  wCal: 0.040, wSteps: 0.5, mult: 1.05, met: 4 },

  // ── MAIS (genéricos) ────────────────────────────────────────────────────────
  natacao:             { category: "Natação",               wDur: 3.2, wDist: 25,  wCal: 0.060, wSteps: 0,   mult: 1.40, met: 8 },
  outro:               { category: "Mais",                  wDur: 2.5, wDist: 10,  wCal: 0.040, wSteps: 1.0, mult: 1.00, met: 4 },
};

// ── CALORIAS ─────────────────────────────────────────────────────────────────

/**
 * Peso usado quando a pessoa ainda não fez avaliação corporal. É uma estimativa
 * declaradamente grosseira — por isso `estimarCalorias` devolve `aproximado`,
 * para a tela poder dizer que o número é aproximado em vez de fingir precisão.
 */
export const PESO_PADRAO_KG = 70;

/**
 * kcal = MET × peso(kg) × horas — a fórmula do Compendium of Physical
 * Activities, a mesma fonte de onde saíram os METs da tabela acima.
 *
 * POR QUE ISTO EXISTE: o check-in pede "Calorias (kcal)" num campo em branco e
 * ninguém preenche. Quem não preenche fica com 0, e o 0 vai para a soma da
 * semana — era a barra "Calorias da semana: 0 kcal" com dois dias de treino
 * marcados. A pessoa já forneceu o que basta para estimar: a modalidade (MET) e
 * a duração. O peso vem da última avaliação corporal.
 *
 * Só a DURAÇÃO alimenta a conta. Distância e passos existem no formulário, mas
 * misturá-los aqui contaria o mesmo esforço duas vezes — quem corre 5 km em 30
 * min já teve os 30 min contados.
 *
 * @param {object} args `{ key, durationMin, pesoKg }`
 * @returns {{kcal: number, met: number, aproximado: boolean}}
 */
export const estimarCalorias = ({ key, durationMin, pesoKg } = {}) => {
  const min = Number(durationMin) || 0;
  const cfg = POINTS_CONFIG[key] || POINTS_CONFIG.outro;
  const met = Number(cfg.met) || Number(POINTS_CONFIG.outro.met);
  const peso = Number(pesoKg) > 0 ? Number(pesoKg) : PESO_PADRAO_KG;

  // Sem duração não há o que estimar: devolver um número aqui seria inventar.
  if (min <= 0) return { kcal: 0, met, aproximado: !(Number(pesoKg) > 0) };

  return {
    kcal: Math.round(met * peso * (min / 60)),
    met,
    aproximado: !(Number(pesoKg) > 0),
  };
};

/**
 * Fórmula de cálculo de pontos:
 *   base = durMin*wDur + distKm*wDist + cal*wCal + (steps/1000)*wSteps
 *   volumeBonus = 1 + cap(dur/200, 0.5) + cap(dist/40, 0.5) + cap(cal/1500, 0.5) + cap(steps/20000, 0.5)
 *   points = max(1, round(base * mult * volumeBonus))
 *
 * volumeBonus existe para premiar sessões longas sem deixar explodir os pontos.
 */
export const calcPoints = ({ key, durationMin, distanceKm, calories, steps }) => {
  const cfg = POINTS_CONFIG[key] || POINTS_CONFIG.outro;

  const dur  = Number(durationMin)  || 0;
  const dist = Number(distanceKm)   || 0;
  const cal  = Number(calories)     || 0;
  const stp  = Number(steps)        || 0;

  const base =
    dur  * cfg.wDur +
    dist * cfg.wDist +
    cal  * cfg.wCal +
    (stp / 1000) * cfg.wSteps;

  const volumeBonus =
    1 +
    Math.min(0.5, dur  / 200) +
    Math.min(0.5, dist /  40) +
    Math.min(0.5, cal  / 1500) +
    Math.min(0.5, stp  / 20000);

  return Math.max(1, Math.round(base * cfg.mult * volumeBonus));
};

// ── LISTA DE ATIVIDADES (UI) ─────────────────────────────────────────────────

export const ACTIVITIES = [
  // Musculação
  { key: "musculacao",          label: "Musculação",             emoji: "🏋️",  category: "Musculação" },
  { key: "calistenia",          label: "Calistenia",             emoji: "💪",  category: "Musculação" },
  { key: "levantamento_peso",   label: "Levantamento de peso",   emoji: "🏋️‍♂️", category: "Musculação" },
 
  // Corrida
  { key: "corrida",             label: "Corrida",                emoji: "👟",  category: "Corrida" },
 
  // Ciclismo
  { key: "ciclismo",            label: "Ciclismo",               emoji: "🚴",  category: "Ciclismo" },
  { key: "mountain_bike",       label: "Mountain Bike",          emoji: "🚵",  category: "Ciclismo" },
  { key: "spinning",            label: "Spinning",               emoji: "🚴‍♀️", category: "Ciclismo" },
 
  // Máquina de cardio
  { key: "esteira",             label: "Esteira",                emoji: "🏃‍♀️", category: "Máquina de cardio" },
  { key: "eliptica",            label: "Elíptica",               emoji: "⚡",  category: "Máquina de cardio" },
  { key: "remo",                label: "Máquina de remo",        emoji: "🚣",  category: "Máquina de cardio" },
 
  // Mente e corpo
  { key: "yoga",                label: "Yoga",                   emoji: "🧘",  category: "Mente e corpo" },
  { key: "pilates",             label: "Pilates",                emoji: "🤸",  category: "Mente e corpo" },
  { key: "barre",               label: "Barre",                  emoji: "🩰",  category: "Mente e corpo" },
  { key: "meditacao",           label: "Meditação",              emoji: "🧠",  category: "Mente e corpo" },
  { key: "respiracao",          label: "Respiração",             emoji: "🌬️",  category: "Mente e corpo" },
  { key: "mente_e_corpo",       label: "Mente e corpo",          emoji: "🕊️",  category: "Mente e corpo" },
 
  // Treinamento funcional
  { key: "hiit",                label: "HIIT",                   emoji: "🔥",  category: "Treinamento funcional" },
  { key: "crossfit",            label: "CrossFit",               emoji: "💥",  category: "Treinamento funcional" },
  { key: "bootcamp",            label: "Bootcamp",               emoji: "🪖",  category: "Treinamento funcional" },
  { key: "circuito",            label: "Treino em circuito",     emoji: "🔄",  category: "Treinamento funcional" },
  { key: "cross_training",      label: "Cross training",         emoji: "🏅",  category: "Treinamento funcional" },
  { key: "funcional",           label: "Treinamento funcional",  emoji: "⚙️",  category: "Treinamento funcional" },
  { key: "ginastica",           label: "Ginástica",              emoji: "🤸‍♀️", category: "Treinamento funcional" },
 
  // Treino core
  { key: "abdominais",          label: "Exercícios abdominais",  emoji: "🧱",  category: "Treino core" },
  { key: "treino_core",         label: "Treino core",            emoji: "🎯",  category: "Treino core" },
 
  // Aeróbica
  { key: "corda",               label: "Pular corda",            emoji: "🪢",  category: "Aeróbica" },
  { key: "aerobica",            label: "Aeróbica",               emoji: "🎵",  category: "Aeróbica" },
  { key: "zumba",               label: "Zumba",                  emoji: "💃",  category: "Aeróbica" },
  { key: "cardio_misto",        label: "Cardio misto",           emoji: "❤️‍🔥", category: "Aeróbica" },
  { key: "pole_dance",          label: "Pole dance",             emoji: "🎪",  category: "Aeróbica" },
  { key: "danca",               label: "Dança",                  emoji: "🕺",  category: "Aeróbica" },
  { key: "hidroginastica",      label: "Hidroginástica",         emoji: "🌊",  category: "Aeróbica" },
  { key: "jogos_exercicio",     label: "Jogos de exercício",     emoji: "🎮",  category: "Aeróbica" },
 
  // Artes marciais
  { key: "muay_thai",           label: "Muay Thai",              emoji: "🥊",  category: "Artes marciais" },
  { key: "bjj",                 label: "BJJ",                    emoji: "🥋",  category: "Artes marciais" },
  { key: "boxe",                label: "Boxe",                   emoji: "🥊",  category: "Artes marciais" },
  { key: "kickboxing",          label: "Kickboxing",             emoji: "🦵",  category: "Artes marciais" },
  { key: "luta",                label: "Luta",                   emoji: "🤼",  category: "Artes marciais" },
  { key: "artes_marciais",      label: "Artes marciais",         emoji: "🥋",  category: "Artes marciais" },
  { key: "tai_chi",             label: "Tai Chi",                emoji: "☯️",  category: "Artes marciais" },
 
  // Esportes em equipe
  { key: "polo_aquatico",       label: "Polo aquático",          emoji: "🤽",  category: "Esportes em equipe" },
  { key: "futebol",             label: "Futebol",                emoji: "⚽",  category: "Esportes em equipe" },
  { key: "rugby",               label: "Rúgbi",                  emoji: "🏉",  category: "Esportes em equipe" },
  { key: "hoquei_gelo",         label: "Hóquei no gelo",         emoji: "🏒",  category: "Esportes em equipe" },
  { key: "futebol_australiano", label: "Futebol australiano",    emoji: "🏈",  category: "Esportes em equipe" },
  { key: "lacrosse",            label: "Lacrosse",               emoji: "🥍",  category: "Esportes em equipe" },
  { key: "hoquei_grama",        label: "Hóquei sobre a grama",   emoji: "🏑",  category: "Esportes em equipe" },
  { key: "basquete",            label: "Basquete",               emoji: "🏀",  category: "Esportes em equipe" },
  { key: "futebol_americano",   label: "Futebol americano",      emoji: "🏈",  category: "Esportes em equipe" },
  { key: "futevolei",           label: "Futevôlei",              emoji: "🏐",  category: "Esportes em equipe" },
  { key: "handebol",            label: "Handebol",               emoji: "🤾",  category: "Esportes em equipe" },
  { key: "ultimate_frisbee",    label: "Ultimate Frisbee",       emoji: "🥏",  category: "Esportes em equipe" },
  { key: "volei_praia",         label: "Vôlei de praia",         emoji: "🏐",  category: "Esportes em equipe" },
  { key: "voleibol",            label: "Voleibol",               emoji: "🏐",  category: "Esportes em equipe" },
  { key: "esporte_equipe",      label: "Esporte em equipe",      emoji: "🤝",  category: "Esportes em equipe" },
  { key: "cricket",             label: "Cricket",                emoji: "🏏",  category: "Esportes em equipe" },
  { key: "beisebol",            label: "Beisebol",               emoji: "⚾",  category: "Esportes em equipe" },
  { key: "softbol",             label: "Softbol",                emoji: "🥎",  category: "Esportes em equipe" },
 
  // Trilha
  { key: "mochilagem",          label: "Mochilagem",             emoji: "🎒",  category: "Trilha" },
  { key: "trilha",              label: "Trilha",                 emoji: "🥾",  category: "Trilha" },
  { key: "caminhada",           label: "Caminhada",              emoji: "🚶",  category: "Trilha" },
 
  // Escalada
  { key: "escalada_rocha",      label: "Escalada em rocha",      emoji: "🧗",  category: "Escalada" },
  { key: "boulder",             label: "Boulder",                emoji: "🪨",  category: "Escalada" },
  { key: "escalada",            label: "Escalada",               emoji: "🧗‍♂️", category: "Escalada" },
  { key: "escalada_indoor",     label: "Escalada indoor",        emoji: "🧗‍♀️", category: "Escalada" },
 
  // Esporte de raquete
  { key: "squash",              label: "Squash",                 emoji: "🎾",  category: "Esporte de raquete" },
  { key: "racquetball",         label: "Racquetball",            emoji: "🎾",  category: "Esporte de raquete" },
  { key: "tenis",               label: "Tênis",                  emoji: "🎾",  category: "Esporte de raquete" },
  { key: "beach_tenis",         label: "Beach tênis",            emoji: "🎾",  category: "Esporte de raquete" },
  { key: "padel",               label: "Padel",                  emoji: "🏓",  category: "Esporte de raquete" },
  { key: "badminton",           label: "Badminton",              emoji: "🏸",  category: "Esporte de raquete" },
  { key: "pickleball",          label: "Pickleball",             emoji: "🏓",  category: "Esporte de raquete" },
  { key: "paddle",              label: "Paddle",                 emoji: "🏄",  category: "Esporte de raquete" },
 
  // Esportes recreativos
  { key: "surfe",               label: "Surfe",                  emoji: "🏄",  category: "Esportes recreativos" },
  { key: "caiaque",             label: "Caiaque",                emoji: "🛶",  category: "Esportes recreativos" },
  { key: "patinacao",           label: "Patinação",              emoji: "⛸️",  category: "Esportes recreativos" },
  { key: "skate",               label: "Skate",                  emoji: "🛹",  category: "Esportes recreativos" },
  { key: "hipismo",             label: "Hipismo",                emoji: "🐎",  category: "Esportes recreativos" },
  { key: "equitacao",           label: "Equitação",              emoji: "🐴",  category: "Esportes recreativos" },
  { key: "mergulho",            label: "Mergulho",               emoji: "🤿",  category: "Esportes recreativos" },
  { key: "golfe",               label: "Golfe",                  emoji: "⛳",  category: "Esportes recreativos" },
  { key: "tenis_mesa",          label: "Tênis de mesa",          emoji: "🏓",  category: "Esportes recreativos" },
  { key: "arco_flecha",         label: "Arco e flecha",          emoji: "🏹",  category: "Esportes recreativos" },
  { key: "disc_golf",           label: "Disc golf",              emoji: "🥏",  category: "Esportes recreativos" },
  { key: "boliche",             label: "Boliche",                emoji: "🎳",  category: "Esportes recreativos" },
  { key: "esporte_recreativo",  label: "Esporte recreativo",     emoji: "🎯",  category: "Esportes recreativos" },
 
  // Natação / Mais
  { key: "natacao",             label: "Natação",                emoji: "🏊",  category: "Natação" },
  { key: "outro",               label: "Outro",                  emoji: "🏃",  category: "Mais" },
];
 

// ── ORDEM DAS CATEGORIAS (UI) ────────────────────────────────────────────────

export const ACTIVITY_CATEGORIES_ORDER = [
  "Musculação",
  "Corrida",
  "Ciclismo",
  "Máquina de cardio",
  "Mente e corpo",
  "Treinamento funcional",
  "Treino core",
  "Aeróbica",
  "Artes marciais",
  "Esportes em equipe",
  "Trilha",
  "Escalada",
  "Esporte de raquete",
  "Esportes recreativos",
  "Natação",
  "Mais",
];

// ── HELPERS ──────────────────────────────────────────────────────────────────

export const groupActivitiesByCategory = (list = ACTIVITIES) =>
  list.reduce((acc, it) => {
    acc[it.category] = acc[it.category] || [];
    acc[it.category].push(it);
    return acc;
  }, {});

export const ACTIVITIES_BY_CATEGORY = groupActivitiesByCategory(ACTIVITIES);

export const getActivityByKey = (key) => ACTIVITIES.find((a) => a.key === key) || null;